import React, {Component}     from 'react';
import { chatFetchData }      from '../../../actions/chat/chat';
import { connect }            from 'react-redux';
import { withRouter }         from 'react-router';
import PubSub                 from 'pubsub-js';
import PropTypes from 'prop-types';

var self;
var emailCheck;

/**
 * This LookUp is responsible for sending requests to Boomi and
 * ServiceNow and recieving and handling the new messages. 
 */
export class ProblemLookUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      result: [],
      email: [],
    };

    this.triggerNext = this.triggerNext.bind(this);
  }

  componentWillMount() {
    self = this; //Used so old components don't get rewritten
    const {steps}  = this.props;
    //Check if user opted to supply an email
    if(typeof steps.userEmail !== 'undefined' && steps.userEmail.value.length > 0) {
        //Used so email doesn't get rendered until everything is ready
        emailCheck = " The email, "+steps.userEmail.value+", will be used for contact purposes.";
        //Attach email and handle new user message
        self.props.fetch("Email: "+steps.userEmail.value+" says: "+steps.problemUser.value);
    } else {
        self.props.fetch(steps.problemUser.value);//Handle new user message with no email attached
    }
    
    
  }

  componentDidMount() {
    //Used to avoid too many calls due to rendering
    this.token = PubSub.subscribe('chat.response', this.subscriber.bind(this));
  }

  subscriber(msg, data) {
    var str = data.Status;  //Save to var to override overwrites
    self.setState({result: str});//Use self to update to the set
    if(!!(emailCheck)) {    //Check if emailCheck isn't null
        self.setState({email: emailCheck})
    }
    self.triggerNext();//Trigger next step

}

  triggerNext() {
      // this.props.triggerNextStep({trigger: 'fun'});
      this.setState({ trigger: true }, () => {
        this.props.triggerNextStep();
      });
  }
    
  render() {
    const { result, email} = this.state;
    /** 
    * {result} is the response from boomi
    * {email} email is the user's email for contact purposes
    */
    return (
        <div>
            {result} 
            {email}
        </div>
    );
  }
}

ProblemLookUp.propTypes = {
  steps: PropTypes.object,
  triggerNextStep: PropTypes.func,
};

ProblemLookUp.defaultProps = {
  steps: undefined,
  triggerNextStep: undefined,
};

const mapStateToProps = state => {
  return {
    chat: state.chat.chat.chat,
    hasErrored: state.chat.chat.chatHasErrored,
    isLoading: state.chat.chat.chatIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host, msg) => dispatch(chatFetchData(host, msg))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProblemLookUp));